import React from 'react';
import { NextPage } from 'next';

import TourService from 'components/tour/_tour';
import { GetAllBranchesAPI } from 'api/space';
import { spaceActions } from 'store/space';

const Tour: NextPage = () => {
  return <TourService />;
};

Tour.getInitialProps = async ({ store }) => {
  const branches = await GetAllBranchesAPI();
  store.dispatch(spaceActions.getBranches(branches.data));

  return {};
};

export default Tour;
